module.exports = __webpack_public_path__ + "static/images/missed.d70054b786a86c444e98b3f91351a6a7.svg";